// extracted by mini-css-extract-plugin
export default {"element":"FavoriteActionButton__element___dclCm","error":"FavoriteActionButton__error___rCul8"};